// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import { OrderedSet } from 'immutable'
import {
  FOOD_JOURNAL_CLEAR_JOURNAL_COMMENTS,
} from './constants';

export function clearJournalComments() {
  return {
    type: FOOD_JOURNAL_CLEAR_JOURNAL_COMMENTS,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FOOD_JOURNAL_CLEAR_JOURNAL_COMMENTS:
      return {
        ...state,
        journalComments: OrderedSet(),
        commentsPagination: null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/food-journal/redux/clearJournalComments.js